const urlConstants = {
  BLOG_SITE: 'https://davekwiatkowski.substack.com',
};

export default urlConstants;
